import { Component, OnDestroy, OnInit } from '@angular/core';
import { SoftwareService } from '../../services/software.service';
import { FacilityService } from 'src/app/core/services/facility.service';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { HaloLoaderService } from '../../../core/halo-loader/halo-loader.service';
import { CommonUtil } from '../../../core/Utils/common-util';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
import { RootScopeService } from 'src/app/core/shared-service/root-scope.service';
import { Subscription } from 'rxjs';
import { IDownloadSoftwareResponse, ISoftwareDownloadVO } from '../../services/software.service.model';
import { environment } from 'src/environments/environment';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';

@Component({
  selector: 'app-download-software',
  templateUrl: './download-software.component.html',
  styleUrls: ['./download-software.component.scss']
})
export class DownloadSoftwareComponent implements OnInit, OnDestroy {
  hasSoftware: boolean = false;
  rootScopeData: RootScopeDeclare;
  currentFacility: FacilityObject;
  downloadSoftwareData: ISoftwareDownloadVO[];
  cloudBasePath: string;
  donotShowSoftwarePop: boolean;

  warningPopupVisible = false;
  warningPopupDontAskMeAgainCheckBox = false;
  warningPopupSelected: ISoftwareDownloadVO;
  warningPopupData = {
    title: 'SOFTWARE.DOWNLOAD.WARNING',
    message: '',
    isWarningPopup: false,
    ctaButtonLabel: 'DOWNLOAD',
    negativeButtonLabel: 'CANCEL',
    isSecondaryTextButton: true,
    hideSecondaryButton: true
  };
  private sub = new Subscription();

  constructor(private softwareService: SoftwareService,
    private _facilityService: FacilityService,
    private loader: HaloLoaderService,
    private rootScopeService: RootScopeService,
    private commonUtil: CommonUtil,
    private _amplitudeAnalytics: AmplitudeAnalyticsService) {
  }

  ngOnInit(): void {
    this.cloudBasePath = environment.cloudBasePath;
    this.getRootScopeData();
    // subscript facility change / when facility change
    this.currentFacility = this._facilityService.selectedFacility();
    this.commonUtil.softwareRedirectToFacility('software');
    let subscriber = this._facilityService.selectedFacilitySource.subscribe((res) => {
      this.currentFacility = res;
      this.getDownloadSoftware();
      this.commonUtil.softwareRedirectToFacility('software');
    });
    this.sub.add(subscriber);
    this.getDownloadSoftware();
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  getRootScopeData(): void {
    this.rootScopeData = this.commonUtil.rootScopeData;
  }

  async getDownloadSoftware() {
    if (this.currentFacility?.facilityId && this.rootScopeData.currentUser.userId) {
      // user permission
      this.hasSoftware = (this.currentFacility.summary.userRights.software === 'F');
      // load data
      this.loader.startProcess();
      try {
        this.downloadSoftwareData = [];
        let data: IDownloadSoftwareResponse = await this.softwareService.getDownloadSoftware(this.currentFacility.facilityId, this.rootScopeData.currentUser.userId.toString()).toPromise();
        this.currentFacility.consoleEquipments?.forEach(c => {
          let software = data?.softwareDownloadVO?.find(s => s.consoleType === c.consoleType);
          if(software && software.hasSoftwareRelease === 'true') this.downloadSoftwareData.push(software);
        });
        this.donotShowSoftwarePop = (data.donotShowSoftwarePop == 'true');
      } catch (error) {
        console.error('API failed.')
      }
      this.loader.endProcess();
    }
  }

  onDownload(data: ISoftwareDownloadVO) {
    if (this.donotShowSoftwarePop || this.warningPopupDontAskMeAgainCheckBox) {
      this.downloadFile(data.consoleType, data.url);
    } else {
      this.warningPopupSelected = data;
      this.warningPopupVisible = true;
    }
  }

  downloadFile(consoleType: string, redirectURL: URL): void {
    window.open(redirectURL.toString());
    // this._amplitudeAnalytics.logEvent(
    //   'Download Software',
    //   {
    //     Console_Type: consoleType
    //   }
    // );
  }

  onWarningCanceled(): void {
    this.warningPopupVisible = false;
  }

  onWarningSuccess(): void {
    this.warningPopupVisible = false;
    this.downloadFile(this.warningPopupSelected.consoleType, this.warningPopupSelected.url);
  }

}
